import script from "./TalkDashboard.vue?vue&type=script&lang=ts&setup=true"
export * from "./TalkDashboard.vue?vue&type=script&lang=ts&setup=true"

import "./TalkDashboard.vue?vue&type=style&index=0&id=4b628c77&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b628c77"]])

export default __exports__